import './polyfills/polyfills'

import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import createHistory from 'history/createBrowserHistory'
import { Provider } from 'react-redux'
import { ApolloProvider } from 'react-apollo'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { WebSocketLink } from 'apollo-link-ws'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { ApolloLink, from } from 'apollo-link'
import ApolloClient from 'apollo-client'

import createStore from './store/createStore'
import { BACKEND_URL, BACKEND_WS_URL } from './constants'
import { initialize as initializeAnalytics } from './analytics'
import { loginComplete } from './actions/user'
import { getMainDefinition } from 'apollo-utilities'
import { parseToken } from './util/parseToken'

const httpLink = createHttpLink({ uri: `${BACKEND_URL}/graphql` })

export const wsClient = new SubscriptionClient(BACKEND_WS_URL, {
  reconnect: true,
  // We close the connection at login/logout to refresh this
  connectionParams: () => {
    const token = window.localStorage.getItem('peikko-dbs-token')
    return { token }
  }
})

const wsLink = new WebSocketLink(wsClient)

const middlewareLink = new ApolloLink((operation, forward) => {
  const token = window.localStorage.getItem('peikko-dbs-token')

  if (token) {
    operation.setContext({
      headers: {
        authorization: `Bearer ${token}`
      }
    })
  }

  if (forward) {
    return forward(operation)
  }
  return null
})

const hasSubscriptionOperation = ({ query }) => {
  const { kind, operation } = getMainDefinition(query)
  return kind === 'OperationDefinition' && operation === 'subscription'
}

const transportLink = ApolloLink.split(
  hasSubscriptionOperation,
  wsLink,
  httpLink
)

const client = new ApolloClient({
  link: from([middlewareLink, transportLink]),
  cache: new InMemoryCache()
})

const history = createHistory({
  basename: undefined
})

// We export store for code-split modules
export const store = createStore(history)

const authToken = window.localStorage.getItem('peikko-dbs-token')
if (authToken) {
  const userData = parseToken(authToken)
  if (userData) {
    store.dispatch(loginComplete(userData))
  }
}

initializeAnalytics()

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App history={history} />
    </Provider>
  </ApolloProvider>,
  document.getElementById('root') as HTMLElement
)



// WEBPACK FOOTER //
// ./src/index.tsx